"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postMessage = exports.PostMessage = void 0;
const protocol_1 = require("./protocol");
const utils_1 = require("../utils");
const message_map_1 = require("./message_map");
/**
 * Communication by post message.
 * For sandbox rendering widget.
 */
class PostMessage extends protocol_1.Protocol {
    constructor() {
        super();
        this.enable = false;
        /**
         * As the window that sends the message, it can communicate with more than one window,
         * and there can be more than one window.
         */
        this.contentWindows = {};
        window.addEventListener('message', (event) => {
            const { origin, data } = event;
            if (!(0, utils_1.isSafeOrigin)(origin)) {
                return;
            }
            const { type, response, messageId } = data;
            const callbacks = this.getCallbacks(type);
            callbacks.forEach(cb => {
                cb(response, messageId);
            });
        }, false);
    }
    emit(type, data, key, messageId, allowTimeout = false) {
        return new Promise((resolve, reject) => {
            if (key) {
                if (this.contentWindows[key]) {
                    const { window: messageWindow, origin } = this.contentWindows[key];
                    messageWindow.postMessage({
                        messageId,
                        response: data,
                        type
                    }, origin);
                    messageId && message_map_1.messageMap.push(messageId, resolve, reject, allowTimeout);
                    return;
                }
                return;
            }
            Object.keys(this.contentWindows).forEach(key => {
                if (!this.contentWindows[key]) {
                    return;
                }
                const { window: messageWindow, origin } = this.contentWindows[key];
                messageWindow && messageWindow.postMessage({
                    messageId,
                    response: data,
                    type
                }, origin);
                messageId && message_map_1.messageMap.push(messageId, resolve, reject, allowTimeout);
            });
        }).catch((e) => {
            console.warn(e);
        });
    }
    /**
     * Add window
     * @param key Unique window ID, generally widgetId for applet forms, and datasheet for main threads.
     * @param window
     */
    addWindow(key, window) {
        this.contentWindows[key] = window;
    }
    /**
     * Remove window
     * @param widgetId
     */
    removeWindow(key) {
        if (!this.contentWindows[key]) {
            console.warn('%s have no window', key);
            return;
        }
        delete this.contentWindows[key];
        // Clear the corresponding window event listener after removing the window.
        this.removeListenEventByKey(key);
    }
}
exports.PostMessage = PostMessage;
exports.postMessage = process.env.SSR ? null : new PostMessage();
